export const isServer = !(
    typeof window !== "undefined"
    && window.document
    && window.document.createElement
);

export const isBrowser = !!(typeof window !== "undefined"
    && window.document
    && window.document.createElement);

export const isTest = typeof describe === "function"
    && typeof it === "function"
    && typeof expect === "function";


export const prefersReducedMotion =
    isBrowser &&
    window.matchMedia &&
    window.matchMedia('(prefers-reduced-motion)').matches

export const supportsResponsiveImages = isBrowser && ('sizes' in document.createElement('img'));
export const supportsIntersectionObserver = isBrowser && ('IntersectionObserver' in window);


// We need to know whether or not we're on an old IE for... reasons.
// @ts-ignore
export const isIE11 = isBrowser && document.documentMode && document.documentMode <= 11;

// We also need to know whether or not we're on Safari because... it's the new IE, basically.
export const isSafari = isBrowser && /^((?!chrome|android).)*safari/i.test(navigator.userAgent);

export const isFirefox = isBrowser && navigator.userAgent.toLowerCase().indexOf('firefox') > -1;
